import { render, staticRenderFns } from "./NewGroupManagementModal.vue?vue&type=template&id=3be063fe&scoped=true"
import script from "./NewGroupManagementModal.vue?vue&type=script&lang=js"
export * from "./NewGroupManagementModal.vue?vue&type=script&lang=js"
import style0 from "./NewGroupManagementModal.vue?vue&type=style&index=0&id=3be063fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be063fe",
  null
  
)

export default component.exports